import { createStore, applyMiddleware } from 'redux'
import { enableBatching } from 'redux-batched-actions'
import { composeWithDevTools } from 'redux-devtools-extension/logOnly'
import thunk from 'redux-thunk'

import rootReducer from '../reducers'
import { enhanceReducer } from 'libs/connectApi'

export default function configureStore(initialState) {
  const store = createStore(
    enhanceReducer(enableBatching(rootReducer)),
    initialState,
    composeWithDevTools(applyMiddleware(thunk))
  )

  return store
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/store/configureStore.prod.js